export const initialState = {
  payment_additional_info: [], // 배열로 관리
};

export const ProductPaymentAdditionalInformationReducer = (state, action) => {
  switch (action.type) {
    // 상태 전체 변경
    case 'SET_PAYMENT_ADDITIONAL_INFO':
      return {
        ...state,
        payment_additional_info: action.value, // 전체 변경
      };

    // 새로운 키-값 추가 (index 관리)
    case 'ADD_DETAIL_INFORMATION':
      return {
        ...state,
        payment_additional_info: [
          ...state.payment_additional_info,
          {
            index: state.payment_additional_info.length, // 현재 길이를 index로 설정
            key: action.key,
            value: action.value,
          },
        ],
      };

    // 특정 인덱스 삭제
    case 'DELETE_DETAIL_INFORMATION':
      return {
        ...state,
        payment_additional_info: state.payment_additional_info.filter(
          (item) => item.index !== action.index
        ),
      };

    // 키 변경 (index 유지)
    case 'CHANGE_DETAIL_INFORMATION':
      return {
        ...state,
        payment_additional_info: state.payment_additional_info.map((item) =>
          item.index === action.index
            ? { ...item, key: action.newKey } // 키만 변경
            : item
        ),
      };

    // 값 변경 (index 유지)
    case 'UPDATE_DETAIL_INFORMATION_VALUE':
      return {
        ...state,
        payment_additional_info: state.payment_additional_info.map((item) =>
          item.index === action.index
            ? { ...item, value: action.value } // 값만 변경
            : item
        ),
      };

    default:
      throw new Error(`Action type '${action.type}'을(를) 찾을 수 없습니다.`);
  }
};

// export const initialState = {
//   payment_additional_info: [], // 배열로 변경하여 순서 유지
// };

// export const ProductPaymentAdditionalInformationReducer = (state, action) => {
//   switch (action.type) {
//     // 상태 전체 변경
//     case 'SET_PAYMENT_ADDITIONAL_INFO':
//       return {
//         ...state,
//         payment_additional_info: action.value, // 배열 형태 유지
//       };

//     // 새로운 키-값 추가 (배열에 객체 형태로 저장)
//     case 'ADD_DETAIL_INFORMATION':
//       return {
//         ...state,
//         payment_additional_info: [
//           ...state.payment_additional_info,
//           { key: action.key, value: action.value }, // 객체 형태로 추가
//         ],
//       };

//     // 특정 키 삭제
//     case 'DELETE_DETAIL_INFORMATION':
//       return {
//         ...state,
//         payment_additional_info: state.payment_additional_info.filter(
//           (item) => item.key !== action.key
//         ),
//       };

//     // 키 변경 (순서 유지)
//     case 'CHANGE_DETAIL_INFORMATION':
//       return {
//         ...state,
//         payment_additional_info: state.payment_additional_info.map((item) =>
//           item.key === action.oldKey
//             ? { ...item, key: action.newKey } // 키만 변경
//             : item
//         ),
//       };

//     // 값 변경 (순서 유지)
//     case 'UPDATE_DETAIL_INFORMATION_VALUE':
//       return {
//         ...state,
//         payment_additional_info: state.payment_additional_info.map((item) =>
//           item.key === action.key
//             ? { ...item, value: action.value } // 값만 변경
//             : item
//         ),
//       };

//     default:
//       throw new Error(`Action type '${action.type}'을(를) 찾을 수 없습니다.`);
//   }
// };
